import {
	LeadsModalModeEnum,
	RoleEnum,
	TabsEnum,
} from '../../../api/models/Enums';
import useModalStore from '../../../store/ModalStore';
import { FaPhoneSlash } from 'react-icons/fa6';
import Btn from '../../Btn/Btn';
import { Col, Row } from 'react-bootstrap';
import useLeadsStore from '../../../store/LeadsStore';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../hooks/useAuth';

const LeadCallsButtons = () => {
	const { openModal } = useModalStore();
	const { activeTab, callCounter } = useLeadsStore();
	const { t } = useTranslation();
	const { userRole } = useAuth();
	const { activeLead } = useLeadsStore();

	return (
		<>
			{activeTab === TabsEnum.NURTURE_LEADS &&
				activeLead?.Phone &&
				[
					RoleEnum.BACKOFFICE,
					RoleEnum.MASTER,
					RoleEnum.SALES,
					RoleEnum.SALES_DEALER,
					RoleEnum.SALES_INTERNAL,
					RoleEnum.AREA_MANAGER,
				].includes(userRole) && (
					<Row className="mb-4">
						<Col md={12} className="d-flex justify-content-end ">
							<Btn
								onClick={() => {
									openModal(LeadsModalModeEnum.PHONE_CALL_NO_REPLY);
								}}
								className="btn-phone-call-register"
							>
								<FaPhoneSlash
									className="no-hover-icon"
									style={{
										fontSize: '20px',
										marginRight: '3px',
										marginBottom: '3px',
										color: 'red',
										width: '23px',
									}}
								/>
								{t('record_phone_call_no_reply')}
								<span className="phone-counter">{callCounter}</span>
							</Btn>
						</Col>
					</Row>
				)}
		</>
	);
};

export default LeadCallsButtons;
